export class DeletedRoleDTOModel {
	FieldCollectionId: number;

	constructor(fieldCollectionId: number) {
		this.FieldCollectionId = fieldCollectionId;
	}
}